'use client'

import { useEffect, useState } from 'react'

/**
 * Debounces a value so a search/filter input can feed a query key without firing a request per
 * keystroke (`frontend-code-standards.md` §14). Combine with TanStack Query's `placeholderData`
 * so the list doesn't flash to a loading state on every keystroke's eventual refetch.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const timeout = setTimeout(() => setDebounced(value), delayMs)
    return () => clearTimeout(timeout)
  }, [value, delayMs])

  return debounced
}
